import React, { useState } from "react";
import { loremIpsum } from "react-lorem-ipsum";
import { Configuration, OpenAIApi } from "openai";
import {useNavigate} from "react-router-dom"
//import Loader from "./Loader";
import Loader from "react-js-loader";

const initialState = {
  text: "",
};

export default function Form(props) {
  const [text, setText] = useState(initialState.text);
  const [textResult, setTextResult] = useState("");
  const [stop, setStop] = useState("");
  const [color, setColor] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const OPENAI_API_KEY = "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";

  const navigate = useNavigate();
  

  const navigateToSocialMediaPost = () => {
    navigate("/tool/socialmediapost")
  };

  const navigateToArticle = () => {
    navigate("/tool/article")
  };

  const handleClear = () => {
    setText("");
    setStop("");
    setColor("");
    props.showAlert("TextBox Cleared", "success");
  };

  const handleClearResult = () => {
    setStop("");
    setColor("");
    setTextResult("");
    props.showAlert("TextBox Cleared", "success");
  };

  //using openAI
  const handleGrammar = async () => {
    setIsLoading(true)
    const configuration = new Configuration({
      apiKey: OPENAI_API_KEY
    });
    const openai = new OpenAIApi(configuration);

    const response = await openai.createCompletion({
      model: "text-davinci-003",
      prompt: "Convert ungrammatical statements into standard English:\n" + text,
      temperature: 0,
      max_tokens: 256,
      top_p: 1.0,
      frequency_penalty: 0.0,
      presence_penalty: 0.0,
    });
    setIsLoading(false)
    setTextResult(response.data.choices[0].text);
    
    setStop("");
    setColor("");
    props.showAlert("Grammer Corrected ", "success");
  };

  //using openAI
  const GenerateCode = async () => {
    setIsLoading(true)
    const configuration = new Configuration({
      apiKey: OPENAI_API_KEY
    });
    const openai = new OpenAIApi(configuration);

    const response = await openai.createCompletion({
      model: "text-davinci-003",
      prompt: "generate python code for the given statement:\n" + text,
      temperature: 0,
      max_tokens: 256,
      top_p: 1.0,
      frequency_penalty: 0.0,
      presence_penalty: 0.0,
    });
    setTextResult(response.data.choices[0].text);
    setIsLoading(false)
    setStop("");
    setColor("");
    props.showAlert("Grammer Corrected ", "success");
  };

  //using openAI
  const InterpretCode = async () => {
    setIsLoading(true)
    const configuration = new Configuration({
      apiKey: OPENAI_API_KEY
    });
    const openai = new OpenAIApi(configuration);

    const response = await openai.createCompletion({
      model: "text-davinci-003",
      prompt: "interpret the code:\n" + text,
      temperature: 0,
      max_tokens: 256,
      top_p: 1.0,
      frequency_penalty: 0.0,
      presence_penalty: 0.0,
    });
    setTextResult(response.data.choices[0].text);
    setIsLoading(false)
    setStop("");
    setColor("");
    props.showAlert("Grammer Corrected ", "success");
  };

  //using openAI
  const bugFixer = async () => {
    setIsLoading(true)
    const configuration = new Configuration({
      apiKey: OPENAI_API_KEY
    });
    const openai = new OpenAIApi(configuration);

    const response = await openai.createCompletion({
      model: "text-davinci-003",
      prompt: "your task is to find and fix bugs in the given python code:\n" + text,
      temperature: 0,
      max_tokens: 512,
      top_p: 1.0,
      frequency_penalty: 0.0,
      presence_penalty: 0.0,
    });
    setTextResult(response.data.choices[0].text);
    setIsLoading(false)
    setStop("");
    setColor("");
    props.showAlert("Bug Fixed ", "success");
  };

  //using openAI
  const CodeEfficiency = async () => {
    setIsLoading(true)
    const configuration = new Configuration({
      apiKey: OPENAI_API_KEY
    });
    const openai = new OpenAIApi(configuration);

    const response = await openai.createCompletion({
      model: "text-davinci-003",
      prompt: "your task is to provide ideas for efficiency improvements of the python code:\n" + text,
      temperature: 0,
      max_tokens: 512,
      top_p: 1.0,
      frequency_penalty: 0.0,
      presence_penalty: 0.0,
    });
    setTextResult(response.data.choices[0].text);
    setIsLoading(true)
    setStop("");
    setColor("");
    props.showAlert("Efficiency Improved", "success");
  };

  //using openAI
  const handleEngHin = async () => {
    setIsLoading(true)
    const configuration = new Configuration({
      apiKey: OPENAI_API_KEY,
    });
    const openai = new OpenAIApi(configuration);

    const response = await openai.createCompletion({
      model: "text-davinci-003",
      prompt: "Translate this from English to Hindi \n\n" + text,
      temperature: 0.3,
      max_tokens: 200,
      top_p: 1.0,
      frequency_penalty: 0.0,
      presence_penalty: 0.0,
    });

    setTextResult(response.data.choices[0].text);
    setIsLoading(false)

    setStop("");
    setColor("");
    props.showAlert("Text Traslated From English to Hindi", "success");
  };

  //using openAI
  const handleHinEng = async () => {
    setIsLoading(true)
    const configuration = new Configuration({
      apiKey: OPENAI_API_KEY,
    });
    const openai = new OpenAIApi(configuration);

    const response = await openai.createCompletion({
      model: "text-davinci-003",
      prompt: "Translate this from Hindi to English \n\n" + text,
      temperature: 0.3,
      max_tokens: 200,
      top_p: 1.0,
      frequency_penalty: 0.0,
      presence_penalty: 0.0,
    });

    setTextResult(response.data.choices[0].text);
    setIsLoading(false)

    setStop("");
    setColor("");
    props.showAlert("Text Traslated From Hindi to English", "success");
  };

  //using openAI
  const handleSentiment = async () => {
    setIsLoading(true)
    const configuration = new Configuration({
      apiKey: OPENAI_API_KEY,
    });
    const openai = new OpenAIApi(configuration);

    const response = await openai.createCompletion({
      model: "text-davinci-003",
      prompt:
        "Decide whether a sentiment is positive, neutral, or negative.\n\n" +
        text,
      temperature: 0,
      max_tokens: 60,
      top_p: 1.0,
      frequency_penalty: 0.5,
      presence_penalty: 0.0,
    });

    setTextResult(response.data.choices[0].text);
    setIsLoading(false)

    setStop("");
    setColor("");
    props.showAlert("Sentiment Generated for the text", "success");
  };

  //using openAI
  const movie2emoji = async () => {
    setIsLoading(true)
    const configuration = new Configuration({
      apiKey: OPENAI_API_KEY,
    });
    const openai = new OpenAIApi(configuration);

    const response = await openai.createCompletion({
      model: "text-davinci-003",
      prompt:
        "Convert movie titles into emoji.\n\nBack to the Future: 👨👴🚗🕒 \nBatman: 🤵🦇 \nTransformers: 🚗🤖 \nStar Wars:  🌟⚔️ \nalien: 👽 \n" +
        text +
        ": ",
      temperature: 0.8,
      max_tokens: 60,
      top_p: 1.0,
      frequency_penalty: 0.0,
      presence_penalty: 0.0,
      stop: ["\n"],
    });

    setTextResult(text + ": " + response.data.choices[0].text);
    setIsLoading(false)

    setStop("");
    setColor("");
    props.showAlert("Sentiment Generated for the text", "success");
  };

  //using openAI
  const mood2color = async () => {
    setIsLoading(true)
    const configuration = new Configuration({
      apiKey: OPENAI_API_KEY,
    });
    const openai = new OpenAIApi(configuration);

    const response = await openai.createCompletion({
      model: "text-davinci-003",
      prompt:
        "The CSS code for a color like a " + text + ":\n\nbackground-color: #",
      temperature: 0,
      max_tokens: 64,
      top_p: 1.0,
      frequency_penalty: 0.0,
      presence_penalty: 0.0,
      stop: [";"],
    });

    setColor("#" + response.data.choices[0].text);
    setIsLoading(false)

    setStop("");
    props.showAlert("Color Generated for the text(Mood)", "success");
  };

  //using openAI
  const extractKeyword = async () => {
    setIsLoading(true)
    const configuration = new Configuration({
      apiKey: OPENAI_API_KEY,
    });
    const openai = new OpenAIApi(configuration);

    const response = await openai.createCompletion({
      model: "text-davinci-003",
      prompt: "Extract keywords from this text:\n\n" + text,
      temperature: 0.3,
      max_tokens: 60,
      top_p: 1.0,
      frequency_penalty: 0.8,
      presence_penalty: 0.0,
    });

    setTextResult("Keywords from the given text:\n " + response.data.choices[0].text);
    setIsLoading(false)
    setColor("");
    setStop("");
    props.showAlert("Keywords Generated", "success");
  };

  //using openAI
  const genIdeas = async () => {
    setIsLoading(true)
    const configuration = new Configuration({
      apiKey: OPENAI_API_KEY,
    });
    const openai = new OpenAIApi(configuration);

    const response = await openai.createCompletion({
      model: "text-davinci-003",
      prompt: "Brainstorm some ideas " + text + ": ",
      temperature: 0.6,
      max_tokens: 350,
      top_p: 1.0,
      frequency_penalty: 1,
      presence_penalty: 1,
    });

    setTextResult(
      "The Ideas for the keyword (" +
        text +
        "): \n" +
        response.data.choices[0].text
    );
    setIsLoading(false)
    setColor("");
    setStop("");
    props.showAlert("Color Generated for the text(Mood)", "success");
  };

  //using openAI
  const genTextbyQuery = async () => {
    setIsLoading(true)
    const configuration = new Configuration({
      apiKey: OPENAI_API_KEY,
    });
    const openai = new OpenAIApi(configuration);

    const response = await openai.createCompletion({
      model: "text-davinci-003",
      prompt: text,
      temperature: 0.6,
      max_tokens: 1550,
      top_p: 1.0,
      frequency_penalty: 1,
      presence_penalty: 1,
    });

    setTextResult(response.data.choices[0].text);
    setIsLoading(false)
    setColor("");
    setStop("");
    props.showAlert("Color Generated for the text(Mood)", "success");
  };

  const handleUpClick = () => {
    setIsLoading(true)
    let newText = text.toUpperCase();
    setTextResult(newText);
    setIsLoading(false)
    setStop("");
    setColor("");
    props.showAlert("Converted to Uppercase", "success");
  };

  const handleLoClick = () => {
    setIsLoading(true)
    let newText = text.toLowerCase();
    setTextResult(newText);
    setIsLoading(false)
    setStop("");
    setColor("");
    props.showAlert("Converted to lowercase", "success");
  };

  const handleCamelCase = () => {
    setIsLoading(true)
    let newText = text
      .toLowerCase()
      .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
    setTextResult(newText);
    setIsLoading(false)
    setStop("");
    setColor("");
    props.showAlert("Converted to Camelcase", "success");
  };

  const handleAltCase = () => {
    setIsLoading(true)
    var midText = text.toLowerCase().split("");
    console.log(midText);
    for (var i = 0; i < midText.length; i += 2) {
      midText[i] = midText[i].toUpperCase();
      console.log(midText[i]);
    }
    const newText = midText.join("");
    setTextResult(newText);
    setIsLoading(false)
    setStop("");
    setColor("");
    props.showAlert("Converted to Alternate Case", "success");
  };

  const handleSenCase = () => {
    setIsLoading(true)
    let newText = text.charAt(0).toUpperCase() + text.slice(1);
    setTextResult(newText);
    setStop("");
    setColor("");
    props.showAlert("Converted to Sentence Case", "success");
  };

  const handleTitleCase = () => {
    let newText = text.replace(/\w\S*/g, function (t) {
      return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
    });
    setTextResult(newText);
    setIsLoading(false)
    setStop("");
    setColor("");
    props.showAlert("Converted to Title Case", "success");
  };

  const handleGenrateText = () => {
    setIsLoading(true)
    let count = 2;
    let newText = loremIpsum({ p: count });
    setTextResult(newText.toString());
    setIsLoading(false)
    setStop("");
    setColor("");
    props.showAlert("Dummy Text Generated", "success");
  };

  const handleSplit = () => {
    setIsLoading(true)
    let newText = text.split(" ");
    setTextResult(newText.join("\r\n"));
    setIsLoading(false)
    setStop("");
    setColor("");
    props.showAlert("Text Splited in Chunks", "success");
  };

  const handleJoin = () => {
    setIsLoading(true)
    let newText = "";
    if (text.includes("\r\n")) {
      newText = text.split("\r\n").join(" ");
    } else {
      newText = text.split("\n").join(" ");
    }
    setTextResult(newText);
    setIsLoading(false)
    setStop("");
    setColor("");
    props.showAlert("Text Joined ", "success");
  };

  const handleReverse = () => {
    setIsLoading(true)
    let newText = text.split("").reverse().join("");
    setTextResult(newText);
    setIsLoading(false)
    setStop("");
    setColor("");
    props.showAlert("Text Reversed", "success");
  };

  const handleRemoveEmpty = () => {
    setIsLoading(true)
    let regex = /^\s*$(?:\r\n?|\n)/gm;
    let newText = text.replace(regex, "");
    setTextResult(newText);
    setIsLoading(false)
    setStop("");
    setColor("");
    props.showAlert("Empty Lines Removed", "success");
  };

  const handleDuplicateLines = () => {
    setIsLoading(true)
    const newLineExpression = /\r\n|\n\r|\n|\r/g;
    let newText = text
      .split(newLineExpression)
      .filter((item, index, array) => array.indexOf(item) === index)
      .join("\n");
    setTextResult(newText);
    setIsLoading(false)
    setStop("");
    setColor("");
    props.showAlert("Duplicate Lines Removed", "success");
  };

  const handleDuplicateWords = () => {
    setIsLoading(true)
    let newText = text
      .split(/\s+/)
      .filter(function (item, i, allItems) {
        return i === allItems.indexOf(item);
      })
      .join(" ");
    setTextResult(newText);
    setIsLoading(false)
    setStop("");
    setColor("");
    props.showAlert("Duplicate Words Removed", "success");
  };

  const handleStopWord = () => {
    setIsLoading(true)
    const stopwords = [
      "i",
      "me",
      "my",
      "myself",
      "we",
      "our",
      "ours",
      "ourselves",
      "you",
      "your",
      "yours",
      "yourself",
      "yourselves",
      "he",
      "him",
      "his",
      "himself",
      "she",
      "her",
      "hers",
      "herself",
      "it",
      "its",
      "itself",
      "the",
      "they",
      "them",
      "their",
      "theirs",
      "themselves",
      "what",
      "which",
      "who",
      "whom",
      "this",
      "that",
      "these",
      "those",
      "am",
      "is",
      "are",
      "was",
      "were",
      "be",
      "been",
      "being",
      "have",
      "has",
      "had",
      "having",
      "do",
      "does",
      "did",
      "doing",
      "a",
      "an",
      "the",
      "and",
      "but",
      "if",
      "or",
      "because",
      "as",
      "until",
      "while",
      "of",
      "at",
      "by",
      "for",
      "with",
      "about",
      "against",
      "between",
      "into",
      "through",
      "during",
      "before",
      "after",
      "above",
      "below",
      "to",
      "from",
      "up",
      "down",
      "in",
      "out",
      "on",
      "off",
      "over",
      "under",
      "again",
      "further",
      "then",
      "once",
      "here",
      "there",
      "when",
      "where",
      "why",
      "how",
      "all",
      "any",
      "both",
      "each",
      "few",
      "more",
      "most",
      "other",
      "some",
      "such",
      "no",
      "nor",
      "not",
      "only",
      "own",
      "same",
      "so",
      "than",
      "too",
      "very",
      "s",
      "t",
      "can",
      "will",
      "just",
      "don",
      "should",
      "now",
    ];

    let res = [];
    let words = text.toLowerCase().split(" ");
    for (let i = 0; i < words.length; i++) {
      let word_clean = words[i].split(".").join("");
      if (!stopwords.includes(word_clean)) {
        res.push(word_clean);
      }
    }
    let newText = res.join(" ");
    setTextResult(newText);
    setIsLoading(false)
    setStop(stopwords.join(" "));
    setColor("");
    props.showAlert("Stopwords Removed", "success");
  };

  const handleExtraSpaces = (e) => {
    setIsLoading(true)
    let newText = text.split(/[ ]+/);
    setTextResult(newText.join(" "));
    setIsLoading(false)
    setColor("");
    props.showAlert("Extra spaces Removed", "success");
  };

  const handleOnChange = (e) => {
    setText(e.target.value);
  };

  return (
    <>
      <div>
        {isLoading ? (
        <>
        <div className="row"
             style={{
                      padding:"20px"
                    }}>
          <Loader type="bubble-loop" bgColor={"#5C0091"} size={150} /> 
        </div>
        </>
      ) : (<>
        <div className="row">
          <div className="col-6">
            <h1 className={`text-${props.mode === "light" ? "dark" : "light"}`}>
              <span
                style={{
                  fontSize: "30px",
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  
                }}
              >
                Try
              </span>{" "}
              <span
                style={{
                  fontSize: "40px",
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  
                  fontWeight: 600,
                }}
              >
                TEXTI:
              </span>{" "}
              <span
                style={{
                  fontSize: "30px",
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  
                }}
              >
                Enter The Text
              </span>
            </h1>
          </div>

          <div className="col-6" style={{ textAlign: "right" }}>
            <button
              type="button"
              className="btn btn-light my-2 mx-2"
              onClick={() => {
                navigator.clipboard.writeText(textResult);
                props.showAlert("Textbox Copied", "success");
              }}
              disabled={textResult.length === 0}
            >
              Copy to Clipboard
            </button>
            <button
              type="button"
              className={`btn btn-${
                props.mode === "dark" ? "dark" : "danger"
              } my-2 mx-2`}
              onClick={handleClear}
              disabled={text === "" }
            >
              Clear Text
            </button>
            <button
              type="button"
              className={`btn btn-${
                props.mode === "dark" ? "dark" : "danger"
              } my-2 mx-2`}
              onClick={handleClearResult}
              disabled={textResult === "" }
            >
              Clear Result
            </button>
          </div>
        </div>

        <div className="mb-3 row">
          <div className="col-md-6 my-2">
            <textarea
              className="form-control"
              placeholder="Enter the Text Here"
              value={text}
              id="textForm"
              rows="10"
              onChange={handleOnChange}
              style={{
                backgroundColor: props.mode === "dark" ? "grey" : "white",
                color: props.mode === "dark" ? "white" : "black",
              }}
            ></textarea>
          </div>
          <div className="col-md-6 my-2">
            {" "}
            {color ? (
              <>
                <div
                  style={{
                    width: "400px",
                    height: "250px",
                    backgroundColor: color,
                  }}
                ></div>
              </>
            ) : (
              <>
                <textarea
                  className="form-control"
                  placeholder="Result"
                  value={textResult}
                  id="textOutput"
                  rows="10"
                  onChange={handleOnChange}
                  style={{
                    backgroundColor: props.mode === "dark" ? "grey" : "white",
                    color: props.mode === "dark" ? "white" : "black",
                  }}
                ></textarea>
              </>
            )}
          </div>
        </div>
        <div
        
          className={`container my-3 text-${
            props.mode === "light" ? "dark" : "light"
          }`}
        >
          <div className="row">
              <div className="col-md-6">
              <p
            style={{
              fontSize: "30px",
              fontFamily: "sans-serif",
              fontVariant: "small-caps",
              fontWeight: 600,
            }}
          >
            {" "}
            Text Summary
          </p>
          <p
            style={{
              fontSize: "20px",
              fontFamily: "sans-serif",
              fontVariant: "small-caps",
            }}
          >
            <span
              style={{
                fontWeight: 600,
              }}
            >
              {text === "" ? "0" : text.trim().split(/\s+/).length}{" "}
            </span>
            {text.trim().split(/\s+/).length === 1 ? "word" : "words"} and{" "}
            <span
              style={{
                fontWeight: 600,
              }}
            >
              {text.length}
            </span>{" "}
            Characters and{" "}
            <span
              style={{
                fontWeight: 600,
              }}
            >
              {" "}
              {text === ""
                ? "0"
                : text.split(/\r\n|\r|\n/).length === 1
                ? text.split(/\r\n|\r|\n/).length
                : text.split(/\r\n|\r|\n/).length}
            </span>
            {text === ""
              ? "Lines"
              : text.split(/\r\n|\r|\n/).length === 1
              ? " Line"
              : " Lines"}
          </p>
          <p
            style={{
              fontSize: "20px",
              fontFamily: "sans-serif",
              fontVariant: "small-caps",
            }}
          >
            {" "}
            <span
              style={{
                fontWeight: 600,
              }}
            >
              {text === "" ? "0" : 0.008 * text.split(" ").length}
            </span>{" "}
            Minutes Of Read
          </p>
              </div>
              <div className="col-md-6">
              <p
            style={{
              fontSize: "30px",
              fontFamily: "sans-serif",
              fontVariant: "small-caps",
              fontWeight: 600,
              textAlign:"right",
            }}
          >
            {" "}
            Result Text Summary
          </p>
          <p
            style={{
              fontSize: "20px",
              fontFamily: "sans-serif",
              fontVariant: "small-caps",
              textAlign:"right",
            }}
          >
            <span
              style={{
                fontWeight: 600,
              }}
            >
              {textResult === "" ? "0" : textResult.trim().split(/\s+/).length}{" "}
            </span>
            {textResult.trim().split(/\s+/).length === 1 ? "word" : "words"} and{" "}
            <span
              style={{
                fontWeight: 600,
              }}
            >
              {textResult.length}
            </span>{" "}
            Characters and{" "}
            <span
              style={{
                fontWeight: 600,
              }}
            >
              {" "}
              {textResult === ""
                ? "0"
                : textResult.split(/\r\n|\r|\n/).length === 1
                ? textResult.split(/\r\n|\r|\n/).length
                : textResult.split(/\r\n|\r|\n/).length}
            </span>
            {textResult === ""
              ? "Lines"
              : textResult.split(/\r\n|\r|\n/).length === 1
              ? " Line"
              : " Lines"}
          </p>
          <p
            style={{
              fontSize: "20px",
              fontFamily: "sans-serif",
              fontVariant: "small-caps",
              textAlign:"right",
            }}
          >
            {" "}
            <span
              style={{
                fontWeight: 600,
              }}
            >
              {textResult === "" ? "0" : 0.008 * textResult.split(" ").length}
            </span>{" "}
            Minutes Of Read
          </p>
              </div>
            </div>
          
        </div>

        <div className="container">
          <p
            className={`text-${props.mode === "light" ? "dark" : "light"}`}
            style={{
              fontSize: "30px",
              fontFamily: "sans-serif",
              fontVariant: "small-caps",
              fontWeight: 600,
            }}
          >
            {stop ? "Stopwords: " + stop.split(" ").length + " words" : ""}
          </p>
          <p
            className={`text-${props.mode === "light" ? "dark" : "light"}`}
            style={{
              fontSize: "18px",
              fontFamily: "sans-serif",
              fontVariant: "small-caps",
            }}
          >
            {stop}
          </p>
        </div>

        <div className="row">
          <p
            className={`text-${props.mode === "light" ? "dark" : "light"}`}
            style={{
              fontSize: "30px",
              fontFamily: "sans-serif",
              fontVariant: "small-caps",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            Tools
          </p>
          <div className="col-md-6">

          <div className="row">
              <div className="col-md-1 "></div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "success"
                  } my-2 mx-2`}
                  onClick={navigateToSocialMediaPost}
                  style={{ width: "100%", height: "100%" }}
                >
                  Social Media Post
                </button>
              </div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "success"
                  } my-2 mx-2`}
                  onClick={navigateToArticle}
                  style={{ width: "100%", height: "100%" }}
                >
                  Article Generator
                </button>
              </div>
              
              
              <div className="col-md-1 "></div>
            </div>

            <div className="row">
              <div className="col-md-1 "></div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "success"
                  } my-2 mx-2`}
                  onClick={handleGenrateText}
                  style={{ width: "100%", height: "100%" }}
                >
                  Generate Text
                </button>
              </div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "success"
                  } my-2 mx-2`}
                  onClick={handleStopWord}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Remove Stop Words
                </button>
              </div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "success"
                  } my-2 mx-2`}
                  onClick={extractKeyword}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Extract Keywords
                </button>
              </div>
              <div className="col-md-1 "></div>
            </div>
            <div className="row">
              <div className="col-md-1 "></div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "info"
                  } my-2 mx-2`}
                  onClick={handleGrammar}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Grammar Correct
                </button>
              </div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "info"
                  } my-2 mx-2`}
                  onClick={handleEngHin}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  English to Hindi
                </button>
              </div>
              <div className="col-md-3 mx-2 my-2 ">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "info"
                  } my-2 mx-2`}
                  onClick={handleHinEng}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Hindi to English
                </button>
              </div>
              <div className="col-md-1 "></div>
            </div>
            <div className="row">
              <div className="col-md-1 "></div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "warning"
                  } my-2 mx-2`}
                  onClick={handleSentiment}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Find Sentiment
                </button>
              </div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "warning"
                  } my-2 mx-2`}
                  onClick={movie2emoji}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Movie to Emoji
                </button>
              </div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "warning"
                  } my-2 mx-2`}
                  onClick={mood2color}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Mood to Color
                </button>
              </div>
              <div className="col-md-1 "></div>
            </div>

            <div className="row">
              <div className="col-md-1 "></div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "warning"
                  } my-2 mx-2`}
                  onClick={genIdeas}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Generate Ideas
                </button>
              </div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "warning"
                  } my-2 mx-2`}
                  onClick={genTextbyQuery}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Generate Text by Query
                </button>
              </div>
              <div className="col-md-1 "></div>
            </div>

            <div className="row">
              <div className="col-md-1 "></div>
            
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "danger"
                  } my-2 mx-2`}
                  onClick={GenerateCode}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Generate Python Code
                </button>
              </div>

              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "danger"
                  } my-2 mx-2`}
                  onClick={InterpretCode}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Interpret The code
                </button>
              </div>

              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "danger"
                  } my-2 mx-2`}
                  onClick={bugFixer}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Python Bug Fixer
                </button>
              </div>

              <div className="col-md-1 "></div>
            </div>

            <div className="row">
              <div className="col-md-1 "></div>
            
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "danger"
                  } my-2 mx-2`}
                  onClick={CodeEfficiency}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Code Efficiency
                </button>
              </div>

              <div className="col-md-1 "></div>
            </div>
            
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-1 "></div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "primary"
                  }`}
                  onClick={handleUpClick}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  to UPPERCASE
                </button>
              </div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "primary"
                  } my-2 mx-2`}
                  onClick={handleLoClick}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  to lowercase
                </button>
              </div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "primary"
                  } my-2 mx-2`}
                  onClick={handleCamelCase}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  to camelCase
                </button>
              </div>
              <div className="col-md-1"></div>
            </div>

            <div className="row">
              <div className="col-md-1"></div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "primary"
                  } my-2 mx-2`}
                  onClick={handleAltCase}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  to aLtErNaTe CaSe
                </button>
              </div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "primary"
                  } my-2 mx-2`}
                  onClick={handleSenCase}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  to Sentence case
                </button>
              </div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "primary"
                  } my-2 mx-2`}
                  onClick={handleTitleCase}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  to Title Case
                </button>
              </div>
              <div className="col-md-1"></div>
            </div>

            <div className="row">
              <div className="col-md-1"></div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "primary"
                  } my-2 mx-2`}
                  onClick={handleSplit}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Split Text
                </button>
              </div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "primary"
                  } my-2 mx-2`}
                  onClick={handleJoin}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Join Text
                </button>
              </div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "primary"
                  } my-2 mx-2`}
                  onClick={handleReverse}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Reverse Text
                </button>
              </div>
              <div className="col-md-1"></div>
            </div>

            <div className="row">
              <div className="col-md-1"></div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "primary"
                  } my-2 mx-2`}
                  onClick={handleRemoveEmpty}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Remove Empty LInes
                </button>
              </div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "primary"
                  } my-2 mx-2`}
                  onClick={handleDuplicateLines}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Remove Duplicate Lines
                </button>
              </div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "primary"
                  } my-2 mx-2`}
                  onClick={handleDuplicateWords}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Remove Duplicate Words
                </button>
              </div>
              <div className="col-md-1"></div>
            </div>

            <div className="row">
              <div className="col-md-1"></div>
              <div className="col-md-3 mx-2 my-2">
                <button
                  type="button"
                  className={`btn btn-${
                    props.mode === "dark" ? "dark" : "primary"
                  } my-2 mx-2`}
                  onClick={handleExtraSpaces}
                  disabled={text.length === 0}
                  style={{ width: "100%", height: "100%" }}
                >
                  Remove Extra Space
                </button>
              </div>
              <div className="col-md-1"></div>
            </div>
          </div>
        </div>
        </>)}

      </div>
    </>
  );
}
